<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  // mounted(){
  //   this.countViewCount()
  // }
}

</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
/deep/ .amap-logo {display: none!important;opacity: 0 !important;}
/deep/ .amap-copyright {opacity: 0!important;}
#app {
  min-height: 100vh;
}

.main-content-area{
  min-height: calc(100vh - 352px);
}
// .container-fluid{
//   padding: 0 10px!important;
// }
.overHidden {
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  text-overflow: ellipsis;
}

.overHidden2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.overHidden3{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.overHidden4 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.html-div{
  white-space: pre-wrap;
  img{
    max-width: 100%;
  }
}
.flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.justify-center {
  justify-content: center;
}

.justify-around {
  justify-content: space-around;
}

.justify-between {
  justify-content: space-between;
}

.justify-end {
  justify-content: flex-end;
}
.justify-start{
  justify-content: flex-start;
}
.align-start{
  align-content: flex-start;
}
.align-center {
  align-items: center;
}

.align-end {
  align-items: flex-end;
}
.align-baseline{
  align-items: baseline;
}

.page-model-title-line {
  z-index: 4;
}
.page-middle-content-row{
  padding: 0 10px;
  >div{
    padding: 0;
  }
}
.page-model-title-row{
  padding: 0 10px;
  >div{
    padding: 0;
  }
}
.page-model-title {
  z-index: 4;
  position: relative;
  
  >span:last-of-type {
    font-family: 'CN Heavy';
    font-weight: bold;
    // font-size: 36px;
    font-size: 48px;
    color: #333333;
    // line-height: 54px;
    line-height: 72px;
  }

  >span:first-of-type {
    font-family: 'YouSheBiaoTiHei';
    // font-size: 36px;
    font-size: 48px;
    color: #1566D4;
    // line-height: 47px
    line-height: 62px;
  }
}

.page-model-right {
  z-index: 4;
  user-select: none;
  cursor: pointer;
  .page-model-right-info {
    font-family: 'SourceHanSansCN-Regular';
    // font-size: 12px;
    font-size: 16px;
    color: #3B7AF4;
    line-height: 18px;
  }

  img {
    width: 50px;
    height: 14px;
    margin-left: 8px;
    // object-fit: contain;
  }
}
.detail-bg .bg-img,.area-bg  .bg-img{
      width: 100%;
      height: 780px;
    //   background-image: url('../../assets/image/bg33.png');
    //   background-size: 1920px 780px;
    //   background-position: 50% 0;
    //   background-repeat: no-repeat;
      // background: linear-gradient( 180deg, rgba(21,102,212,0.2) 0%, rgba(255,255,255,100) 100%);
      background: linear-gradient( 180deg, rgba(21,102,212,0.2) 0%, rgba(21,102,212,0) 100%);
      margin: 0 auto;
      img{
        max-width: 1920px;
        height: 780px;
        object-fit: cover;
        margin: 0 auto;
      }
}

@font-face {
  font-family: 'SourceHanSansCN-Bold';
  src: url('./assets/fonts/Source Han Sans CN Bold.woff')
}

@font-face {
  font-family: 'SourceHanSansCN-Regular';
  src: url('./assets/fonts/SourceHanSansCN-Regular.otf');
}

@font-face {
  font-family: 'YouSheBiaoTiHei';
  src: url('./assets/fonts/YouSheBiaoTiHei.woff')
}
@font-face{
  font-family: 'CN Heavy';
  // src: url('./assets/fonts/CN\ Heavy.ttf');
  src: url('./assets/fonts/CN\ Heavy.woff');
}


// 移动端
@media (min-width: 576px)and (max-width:1200px){
  .overHidden{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box-flex;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
white-space: nowrap;
word-break: break-all;
  }
  .detail-bg .bg-img,.area-bg  .bg-img{
    img{
      // width: 750px;
      width: 100%;
    }
  }
  .page-middle-content-row{
  padding: 0 24px;
  >div{
    padding: 0;
  }
}

.page-model-title-row{
  padding: 0 24px;
  >div{
    padding: 0;
  }
  .page-model-right-info{
  font-size: 24px!important;
}
}
}
</style>
